import * as React from "react"
import {InputAddon, SelectInput, SelectInputOption, SelectInputProps} from "@vebox/etui-core";
import {Display} from "../../components/Display";

interface EditableSelectInputProps {
    onCancel: () => void
}

export const EditableSelectInput: React.FC<SelectInputProps & EditableSelectInputProps> = ({
                                                                                               defaultValue,
                                                                                               disabled,
                                                                                               error,
                                                                                               value,
                                                                                               onCancel,
                                                                                               readOnly,
                                                                                               ...rest
                                                                                           }) => {
    const [showPencil, setShowPencil] = React.useState<boolean>(true);
    const [isTextValueModified, setIsTextValueModified] = React.useState<boolean>(false);

    const inputRef = React.useRef(null)


    const focusOnInputText = () => {
        inputRef.current.select.focus()
    }

    const handleOnCancel = (): void => {
        if (onCancel) {
            onCancel();
        }
    }

    React.useEffect(() => {
        setIsTextValueModified((value as SelectInputOption)?.value !== (defaultValue as SelectInputOption)?.value)
    }, [value])

    const showEditInputAddon = (show: boolean) => () => setShowPencil(show)

    return <SelectInput
        value={value}
        onMenuClose={showEditInputAddon(true)}
        onMenuOpen={showEditInputAddon(false)}
        defaultValue={defaultValue}
        error={error}
        elRef={inputRef}
        readOnly={readOnly}
        disabled={disabled}
        endInputAddon={
            <Display isVisible={!disabled && !readOnly}>
                {showPencil && !isTextValueModified
                    ? (
                        <InputAddon position="end">
                            <span
                                onClick={focusOnInputText}
                                className="material-icons clickable edit-icon"
                            >edit</span>
                        </InputAddon>
                    )
                    : null}
                {isTextValueModified
                    ? (
                        <InputAddon position="end">
                            <span
                                onClick={handleOnCancel}
                                className="material-icons clickable cancel-icon"
                            >clear</span>
                        </InputAddon>
                    )
                    : null}
            </Display>
        }
        {...rest}
    />
}